

import { requests } from '@/tool/util'

export function Login(formData) {
    return requests("post",{
        url: "Index/login",
        data: formData
    })
}

export function Register(formData) {
    return requests("post",{
        url: "Index/register",
        data: formData
    })
}

export function Logout() {
    return requests("post",{
        url: "Index/logOut",
    })
}

export function GetUserInfo() {
    return requests("get",{
        url: "Index/userinfo",
    })
}

export function GetRoutes() {
    return requests("get",{
        url: "Index/menus",
    })
}

export function GetMobileCode(formData) {
    return requests("post",{
        url: "Index/getMobileCode",
        data: formData
    })
}

export function GetMobileVerifyCode(formData) {
    return requests("post",{
        url: "Index/getMobileVerifyCode",
        data: formData
    })
}

export function VerifyCode(formData) {
    return requests("post",{
        url: "Index/verifyCode",
        data: formData
    })
}

export function RealName(formData) {
    return requests("post",{
        url: "Users/realName",
        data: formData
    })
}

export function Enterprise(formData) {
    return requests("post",{
        url: "Users/enterprise",
        data: formData
    })
}


export function UserCert() {
    return requests("get",{
        url: "Users/cert",
    })
}

export function ChangePasswd(formData) {
    return requests("post",{
        url: "Users/changePasswd",
        data: formData
    })
}

export function UpdateUser(formData = {}) {
    return requests("post",{
        url: `Users/update`,
        data: formData
    })
}

/**
 * 
 * @param {*} formData 
 * @returns 
 */
export function BindMobile(formData) {
    return requests("post",{
        url: `Users/bind`,
        data: formData
    })
}


export function MobileCode(formData) {
    return requests("get",{
        url: `Users/mobile`,
        data: formData
    })
}


/**
 * 
 * @param {*} formData 
 * @returns 
 */
export function BindEmail(formData) {
    return requests("post",{
        url: `Users/email`,
        data: formData
    })
}

export function SaveUserinfo(formData) {
    return requests("post",{
        url: `Index/SaveUserinfo`,
        data: formData
    })
}